import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Grid, Modal, Backdrop, TextareaAutosize, TextField, InputAdornment, Chip } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../../api/DnerhsApi";
import FormInput from "../../../Controls/Input";
import FormSelect from "../../../Controls/Select";
import Alert from "../../../components/Alert";
import history from "../../../utils/History";
import { useParams, useLocation, Link } from "react-router-dom";
import useAuth from "../../../hooks/Auth";
import Roles from "../../../constants/Roles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { Meses, findById } from "../../../constants/Meses";
import EditIcon from "@material-ui/icons/Edit";
import PracticaEstudianteDialog from "../../../dialogs/PracticaEstudianteDialog";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SearchIcon from "@material-ui/icons/Search";
import PeopleIcon from "@material-ui/icons/People";
import DateRangeIcon from "@material-ui/icons/DateRange";
import AssignmentIcon from "@material-ui/icons/Assignment";
import EstadosCronograma from "../../../constants/EstadosCronograma";
import RectificadoModal from "../../../dialogs/RectificadoModal";
import { getCarrerasProgramas, getTutores, getEstudiantes } from "services/ConvenioService";
import { getAllEstablecimientos } from "services/InstitucionService";
import FormDatePicker from "../../../Controls/DatePicker";
import ConfirmDialog from "dialogs/ConfirmDialog";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { trackPromise } from 'react-promise-tracker';
import { getMapHorarioStorage , setMapHorarioStorage} from "services/UsuarioService";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import DeleteDialog from "../../../dialogs/DeleteDialog";
import moment from "moment";

const formatDateOnly = (value) => {
  if (!value) {
    return "";
  }

  const textValue = String(value);
  const isoDateMatch = textValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDateMatch) {
    return `${isoDateMatch[3]}/${isoDateMatch[2]}/${isoDateMatch[1]}`;
  }

  const localDateMatch = textValue.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (localDateMatch) {
    return `${localDateMatch[1]}/${localDateMatch[2]}/${localDateMatch[3]}`;
  }

  const parsedDate = moment(textValue);
  return parsedDate.isValid() ? parsedDate.format("DD/MM/YYYY") : textValue;
};

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  modal: {
    position:'absolute',
    width: 800,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,2),
    //padding: "30px 80px 60px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
  },outline: 'none'
  },
  // Estilos profesionales para las mejoras
  statsContainer: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#ffffff',
    borderRadius: 8,
    border: '1px solid #e9ecef',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  statChip: {
    margin: theme.spacing(0.5),
    fontWeight: 600,
    fontSize: '0.875rem'
  },
  searchContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    border: '1px solid #e9ecef'
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    '& th': {
      fontWeight: 600,
      color: '#495057',
      borderBottom: '2px solid #dee2e6'
    }
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f8f9fa'
    },
    '&:hover': {
      backgroundColor: '#e9ecef'
    }
  },
  actionsCell: {
    width: 128,
    minWidth: 128,
    padding: theme.spacing(0.75, 1),
    verticalAlign: 'middle'
  },
  actionsBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.75),
    flexWrap: 'nowrap'
  },
  actionButton: {
    width: 32,
    height: 32,
    padding: 4,
    border: '1px solid #dfe3ea',
    backgroundColor: '#ffffff',
    '& svg': {
      fontSize: 20
    },
    '&:hover': {
      backgroundColor: '#f6f8fb'
    }
  },
  viewAction: {
    color: '#e91e63'
  },
  rectificarAction: {
    color: '#333e65'
  },
  editAction: {
    color: '#1976d2'
  },
  deleteAction: {
    color: '#6b7280'
  }
}));

const Form = () => {
  const classes = useStyles();
  const [carreraOptions, setCarreraOptions] = useState([]);
  const [tutoresConvenioList, setTutotresConvenioList] = useState([]);
  const [practicaSelected, setPracticaSelected] = useState({});
  const [fechaDesde, setFechaDesde] = useState();
  const [fechaHasta, setFechaHasta] = useState();
  const [curso, setCurso] = useState();
  const [sent, setSent] = useState(false);
  const [idFormadora, setIdFormadora] = useState();
  const [verHistorial, setIsUpdateH] = useState(false);

  const [establecimientosList, setEstablecimientosList] = useState([]);
  const [plazasList, setPlazasList] = useState([]);
  const [puchOnsaveStudent, setPuchOnsaveStudent] = useState(false);

  
  const [mesesOptions, setMesesOptions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [practicaResponseData, setPracticaResponseData] = useState({});
  const [estudiantesResponseData, setEstudiantesResponseData] = useState([]);
  const [listPracticas, setListPracticas] = useState([]);
  const [openPracticaDialog, setOpenPracticaDialog] = useState(false);
  const [asignadasCount, setAsignadasCount] = useState(0);
  const params = useParams();
  const methods = useForm({});
  const { handleSubmit, errors, setValue, getValues } = methods;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isAprobar, setIsAprobar] = useState(false);
  const { userData, hasRole, hasAnyRole } = useAuth();
  const location = useLocation();
  let { state } = location;

  // SOLUCIÓN BUG: Detectar modo desde URL
  const isVerMode = location.pathname.includes('/ver/');
  const isEditarMode = location.pathname.includes('/editar/');
  const [openDialog, setOpenDialog] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [observacion, setRechazoObservacion] = useState();
  const [bandera, setBandera] = useState("");
  const [botonGuardar, setBotonGuardar] = useState(false);
  let carreraProgramaId="";
  let nombreCarrera="";
  const [mapHorarios, setMmapHorarios] = useState([]);
  const [disabledAgregar, setDisabledAgregar] = useState(true); 
  const [isDisabledGuardar, setIsDisabledGuardar] = useState(false); 
  const [carrAux, setCarrAux] = useState(); 
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [toDelete, setToDelete] = useState();
  const [indexx, setIndex] = useState();
  const [carreras, setCarreras] = useState([]);
  const [isPostgrado, setIsPostgrado] = useState(false);
  const [postgradoId, setPostgradoId] = useState();
  const [contadorAlumnos, setContadorAlumnos] = useState();

  // Estados para las nuevas funcionalidades
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPracticas, setFilteredPracticas] = useState([]);
  const [fechaCreacion, setFechaCreacion] = useState('');

  // Estados para el modal de Rectificado
  const [openRectificadoModal, setOpenRectificadoModal] = useState(false);
  const [selectedEstudiante, setSelectedEstudiante] = useState(null);

  // Función para filtrar las prácticas
  const filterPracticas = (practicas, searchTerm) => {
    if (!searchTerm.trim()) {
      return practicas;
    }

    const term = searchTerm.toLowerCase();
    return practicas.filter(row => {
      const searchableFields = [
        row.convenioEstudiante?.estudiante?.cedulaIdentidad?.toString(),
        row.convenioEstudiante?.estudiante?.nombres,
        row.convenioEstudiante?.estudiante?.apellidos,
        row.convenioEstudiante?.estudiante?.nacionalidad?.nombre,
        row.convenioEstudiante?.convenio?.institucionFormadora?.sede,
        row.convenioEstudiante?.curso?.toString(),
        row.convenioEstudiante?.anio?.toString(),
        row.convenioTutor?.tutor?.cedulaIdentidad?.toString(),
        row.convenioTutor?.tutor?.nombres,
        row.convenioTutor?.tutor?.apellidos,
        row.establecimiento?.nombreServicio?.nombre,
        row.totalHoras?.toString()
      ];

      return searchableFields.some(field =>
        field && field.toLowerCase().includes(term)
      );
    });
  };

  // Efecto para filtrar cuando cambia el término de búsqueda o la lista
  useEffect(() => {
    const filtered = filterPracticas(listPracticas, searchTerm);
    setFilteredPracticas(filtered);
  }, [listPracticas, searchTerm]);

  useEffect(() => {
    const load = () => {
      try {
        getServerData({ convenioId: params.convenioId });

        // ✅ SOLUCIÓN: Leer aprobar ANTES de validar el modo (para que funcionen los botones de aprobación)
        if (state?.aprobar !== undefined) {
          setIsAprobar(state.aprobar);
        }

        // SOLUCIÓN BUG: Detectar modo desde URL primero
        if (isVerMode) {
          console.log("? Modo VER detectado desde URL - Forzando readOnly");
          setIsReadOnly(true);
          setIsDisabledGuardar(true);
          setIsUpdate(false);
          setValuesForEdit();
        } else if (state?.edit || state?.readOnly) {
          setIsUpdate(state.edit);

          // SOLUCIÓN BUG: Si viene de un padre en modo VER, preservar readOnly
          if (state?.parentIsVerMode) {
            console.log("? Padre en modo VER - Preservando readOnly al volver");
            setIsReadOnly(true);
            setIsDisabledGuardar(true);
          } else {
            setIsReadOnly(state.readOnly? true:false);
            setIsDisabledGuardar(isReadOnly);
          }

          getServerData({ convenioId: params.convenioId });
          setValuesForEdit();
        }

        if(!hasRole(Roles.ROLE_DNERHS)){
          loadCantidades();
        }

      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const confirmOne = async () => {
    
    try {
      if (observacion == "") {
        Alert.show({
          message : "Por favor ingrese una observación",
          type : "error"
        });
        return;
      }

      await trackPromise(DnerhsApi.post(
        `/convenios/practicas/${practicaResponseData.id}/finalizar-cronograma?observacion=${observacion}`
      ));
      setSent(true);
      Alert.show({
        message: "El Cronograma de Practicas ha Finalizado exitosamente.",
        type: "success",
      });

     
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
    history.goBack();
    setOpenDialog(false);

  };


  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleOpenCronogramaDialog =  async (index) => {
    if (getValues("carrera")=== "") {
      Alert.showError("El campo carrera es dato requerido");
      return;
    }else{
      let carreraAux=getValues("carrera");
      let carrAux;
      carreraOptions.forEach((el)=>{
        if(el.id===carreraAux){
          carrAux=el.idCarrera;
        }
      });
      let [responseTutores, responseEstudintes] = await Promise.all([
        getTutores(params.convenioId, carrAux),
        getEstudiantes(params.convenioId, carrAux)
      ])
      setTutotresConvenioList(responseTutores.data);
      setEstudiantesResponseData(responseEstudintes.data);
    
    }
    if (getValues("fechaDesde") === null || getValues("fechaDesde") === "") {
      Alert.showError("El campo Fecha Desde es dato requerido");
      return;
    }
    if (getValues("fechaHasta") === null || getValues("fechaHasta") === "") {
      Alert.showError("El campo Fecha Hasta es dato requerido");
      return;
    }
    if(!puchOnsaveStudent)  {
      loadAllSolicitudes();
    }
    
    
    let fechaDes=getValues("fechaDesde");
    setFechaDesde(fechaDes);
    let fechaHas=(getValues("fechaHasta"));
    setFechaHasta(fechaHas);
    setCurso(getValues("curso"))
    setPracticaSelected({});
    setOpenPracticaDialog(true);
  };

  const handleSaveCronogramaPractica = (data) => {
    setMmapHorarios(data.mapsHorarios);
    //setMmapHorarios(getMapHorarioStorage());
    setPuchOnsaveStudent(true);
    let arraySolicitudes=[];
    arraySolicitudes.push(data.solicitudPlaza);
    setPlazasList(arraySolicitudes);
    if (Object.entries(practicaSelected).length > 0) {
      let { estudiante } = data.convenioEstudiante;

      let practicasFilterByEstudianteId = listPracticas.filter(
        (item) =>
          item.convenioEstudiante?.estudiante?.cedulaIdentidad ==
          estudiante.cedulaIdentidad
      );

      if (
        practicasFilterByEstudianteId &&
        practicasFilterByEstudianteId.length > 1
      ) {
       Alert.showError(
          `El alumno " ${estudiante.nombres} ${estudiante.apellidos} ya se encuentra en el cronograma.`
        );
        return;
      }

      let index = listPracticas.findIndex(
        (item) => item.convenioEstudiante?.estudiante?.cedulaIdentidad === practicaSelected.convenioEstudiante?.estudiante?.cedulaIdentidad
      );

      let practicaOriginal = listPracticas[index];

      let practicaCopy = {
        ...practicaOriginal,
        ...data,
      };

      practicaCopy.modificado = practicaOriginal.id && JSON.stringify(practicaOriginal) !== JSON.stringify(practicaCopy);

      let listCopy = [...listPracticas];
      listCopy.splice(index, 1);

      setListPracticas([...listCopy, { ...practicaCopy }]);
      conteoHorarios([...listCopy, { ...practicaCopy }]);

    } else {
      let { estudiante } = data.convenioEstudiante;

      let listPracticasFilter = listPracticas.find(
        (item) =>
          item.convenioEstudiante?.estudiante?.cedulaIdentidad ==
          estudiante.cedulaIdentidad
      );

      if (listPracticasFilter) {
        Alert.showError(
          `El alumno " ${estudiante.nombres} ${estudiante.apellidos} ya se encuentra en el cronograma.`
        );
        return;
      }

      let newPractica = { ...data };

      if (isUpdate) {
        newPractica.modificado = true;
      }

      setListPracticas([...listPracticas, { ...newPractica }]);
      conteoHorarios([...listPracticas, { ...newPractica }]);
    }

    handleCloseCronogramaPractica();
  };

  const handleCloseCronogramaPractica = () => {
    setPracticaSelected({});
    setOpenPracticaDialog(false);
    //conteoHorarios(listPracticas);    
  };

  const getServerData = async ({ convenioId }) => {
    try {

      let [responseCarrerasProgramas, responseEstablecimientos] = await Promise.all([
        getCarrerasProgramas(convenioId),
        getAllEstablecimientos(),
      ]
      )

      setEstablecimientosList(responseEstablecimientos.data);
      loadCarreraOptions(responseCarrerasProgramas.data);
      setCarreras(responseCarrerasProgramas.data);
      loadMesesOptions(Meses);



    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      } 
    }
  };

   /* if (carreras) {
      setCarreraOptions(
        carreras.map((carrera) => ({
          label: carrera.carreraPrograma.descripcion,
          id: carrera.id,
          idCarrera: carrera.carreraPrograma.id
        }))
      );
    }*/
    const loadCarreraOptions = (carreras) => {
      if(carreras[0]?.carreraPrograma?.descripcion ==='Postgrado'){
        setIsPostgrado(true);
        setPostgradoId(carreras[0].carreraPrograma.id);
        setCarreraOptions(     
          carreras.map((carrera) => (
          {
            label: "Postgrado - " +  carrera.nombrePostgrado.descripcion,
            idCarrera: carrera.carreraPrograma.id,
            id: carrera.id,
          }
          ))
        );

      }else{
        setCarreraOptions(     
          carreras.map((carrera) => (
          { label: carrera.carreraPrograma.descripcion,
            id: carrera.id,
            idCarrera: carrera.carreraPrograma.id }
          ))
        );

      } 
     /*setCarreraOptions(
      carreras.map((carrera) => ({
        label: carrera.carreraPrograma.descripcion,
        id: carrera.carreraPrograma.id
      }))
    );*/

  }

  const loadCantidades = async () => {

    try {
      let url = `/usuarios/${userData.userId}`;
      const response = await trackPromise(DnerhsApi.get(url));
      setSent(true);
      const formValues = {
        asignadas: response.data.institucionFormadoraResponsableMaximaAutoridadList[0].formadora.asignadas,
        disponibles:response.data.institucionFormadoraResponsableMaximaAutoridadList[0].formadora.disponibles,
        ocupadas:response.data.institucionFormadoraResponsableMaximaAutoridadList[0].formadora.ocupadas
      };
      setIdFormadora(response.data.institucionFormadoraResponsableMaximaAutoridadList[0].formadora.id);

      Object.keys(formValues).forEach((field) => {
        setValue(field, formValues[field]);
      });
    } catch (error) {
     console.log(error);
    }
  };
 const loadAllSolicitudes = async () => {  
    try {
      let valueCarrera=getValues("carrera");
      let carreraIdprograma;
    let carreraDescripcionPrograma;
    carreraOptions.forEach((el)=>{
      if(el.id===valueCarrera){
        carreraIdprograma=el.idCarrera;
        carreraDescripcionPrograma=el.label;
      }
    });
      let url = `/solicitudes-plazas/${idFormadora}/${carreraIdprograma}/asignaciones`;   
      const response = await trackPromise(DnerhsApi.get(url));  
      setSent(true); 
      let arrayListPlazasPut=[];
      let arrayListPlazasPost=[];
      response.data.forEach((u)=>{        
        if(u.estado==="Aprobado por DNERHS"  || u.estado==="Utilizado"){
          if(typeof(params.practicaId)!= 'undefined' && (u.practicaId!=null  && u.practicaId.toString()===params.practicaId)){
            arrayListPlazasPut.push(u);
          }else{
            if(u.practicaId===null ||  u.practicaId===0 || typeof(u.practicaId)=== 'undefined'){
              arrayListPlazasPost.push(u);
            }
          }
        }
      })
      if(typeof(params.practicaId)!= 'undefined' ||  params.practicaId===null){
        setPlazasList(arrayListPlazasPut);
      }else{
        setPlazasList(arrayListPlazasPost);
      }
      

    } catch (error) {
     console.log(error);
    }   
  };
  const loadMesesOptions = (meses) => {
    if (meses) {
      setMesesOptions(
        meses.map((mes) => ({
          label: mes.nombre,
          id: mes.id,
        }))
      );
    }
  };
      /*
      const inventory = [
        {name: 'apples', quantity: 2},
        {name: 'bananas', quantity: 0},
        {name: 'cherries', quantity: 5}
      ];

      const result = inventory.find(({ name }) => name === 'cherries');

      console.log(result) // { name: 'cherries', quantity: 5 }
      */
  const conteoHorarios= (listPracticas) => { 
    try {
      let arrayHorarios=[];
      listPracticas.forEach((k)=>{
        k.practicaDetalleHorarioList.forEach((ho)=>{
          //debe buscar el horario similar  si hay aumentar contador
          let flagEncontrado = false;       
          //preguntar si existe el dia y horario
          let iterador=0;
          arrayHorarios.forEach((element, index) => {
            iterador++;
            if(element!=null && element.name === (ho.dia.toString()+ho.horarioDesde+ho.horarioHasta)) {
              //si encuentra aumentar cantidad de contador
              arrayHorarios[index] = {name: element.name, cantidad: element.cantidad+1};
              flagEncontrado=true;
            }
          });                          
          if(!flagEncontrado && iterador===arrayHorarios.length){
            //si no existe registrado ese dia y horario se inserta nuevo
            arrayHorarios.push({name: ho.dia.toString()+ho.horarioDesde+ho.horarioHasta, cantidad:1});
          }             
        });
      });
      setMmapHorarios(arrayHorarios);
      setMapHorarioStorage(arrayHorarios);
      console.log(getMapHorarioStorage());
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
  };

  const setValuesForEdit = async () => {
    let contadorAlumnos=0;
    
    try {
      console.log(params)
      setDisabledAgregar(false);
      
      // Obtener la práctica con el id
      const { data: practicaResponseData } = await trackPromise(DnerhsApi.get(
        `/convenios/practicas/${params.practicaId}`
      ));

      console.log('practica', practicaResponseData)

      setCarrAux(practicaResponseData.convenioCarrera.carreraPrograma.id);

      console.log('carreraAux', carrAux);

      // Obtener las prácticas-detalles con la práctica ID
      const { data: practicaDetalleResponseData } = await trackPromise(DnerhsApi.get(
        `/practicas-detalles/${params.practicaId}/practicas-detalles`
      ));
      setContadorAlumnos(practicaDetalleResponseData.length);
      if (practicaDetalleResponseData.length === 0) {
        setListPracticas([]);
      }

      setSent(true);

      practicaResponseData.practicaDetalleList=practicaDetalleResponseData;

      setPracticaResponseData(practicaResponseData);

      // SOLUCIÓN BUG: Validar estado del cronograma y forzar readOnly si está aprobado o pendiente
      // EXCEPCIÓN: Si el usuario es DNERHS, puede editar en algunos estados
      // IMPORTANTE: Estado FINALIZADA está bloqueado para TODOS (incluso DNERHS)
      const estadosReadOnlyParaTodos = [
        EstadosCronograma.PRACTICA_CRONOGRAMA_FINALIZADA  // NADIE puede editar (ni DNERHS)
      ];

      const estadosReadOnlySoloDnerhs = [
        EstadosCronograma.PRACTICA_APROBADA,
        EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA,
        EstadosCronograma.PENDIENTE_APROBACION,
        EstadosCronograma.PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION
      ];

      const isDnerhs = hasRole(Roles.ROLE_DNERHS);

      // Si está FINALIZADA, bloquear para TODOS
      if (estadosReadOnlyParaTodos.includes(practicaResponseData.estado)) {
        console.log(`? Cronograma FINALIZADO - Bloqueado para TODOS (incluso DNERHS)`);
        setIsReadOnly(true);
        setIsDisabledGuardar(true);
      }
      // Si está en otros estados readonly y NO es DNERHS, bloquear
      else if (estadosReadOnlySoloDnerhs.includes(practicaResponseData.estado) && !isDnerhs) {
        console.log(`? Cronograma en estado "${practicaResponseData.estado}" - Forzando readOnly (usuario NO es DNERHS)`);
        setIsReadOnly(true);
        setIsDisabledGuardar(true);
      }
      // Si es DNERHS y NO está finalizada, puede editar
      else if (estadosReadOnlySoloDnerhs.includes(practicaResponseData.estado) && isDnerhs) {
        console.log(`? Cronograma en estado "${practicaResponseData.estado}" - Usuario DNERHS puede editar`);
      }

      // Capturar fecha de creación

      if (practicaResponseData.fechaCreacion) {
        try {
          let fechaCreacion;

          // Intentar diferentes formatos de fecha
          const formatos = [
            'DD-MM-YYYY HH:mm:ss',  // Formato del backend
            'YYYY-MM-DD HH:mm:ss',  // Formato ISO alternativo
            'YYYY-MM-DDTHH:mm:ss',  // Formato ISO con T
            'YYYY-MM-DDTHH:mm:ss.SSS', // Formato ISO con milisegundos
            'YYYY-MM-DDTHH:mm:ss.SSSZ'  // Formato ISO completo
          ];

          for (const formato of formatos) {
            fechaCreacion = moment(practicaResponseData.fechaCreacion, formato);
            if (fechaCreacion.isValid()) {
              break;
            }
          }

          // Si ningún formato específico funciona, intentar parseo automático
          if (!fechaCreacion || !fechaCreacion.isValid()) {
            fechaCreacion = moment(practicaResponseData.fechaCreacion);
          }

          if (fechaCreacion.isValid()) {
            setFechaCreacion(fechaCreacion.format('DD/MM/YYYY'));
          } else {
            setFechaCreacion('Formato de fecha no reconocido');
          }
        } catch (error) {
          setFechaCreacion('Error al procesar fecha');
        }
      } else {
        setFechaCreacion('No disponible');
      }

      await getServerData({ convenioId: practicaResponseData.convenio.id });

      const formValues = {
        carrera: practicaResponseData.convenioCarrera.id,
        //carrera: practicaResponseData.convenioCarrera.carrera.descripcion==="Postgrado"?  practicaResponseData.convenioCarrera.nombrePostgrado.id :  practicaResponseData.convenioCarrera.id,

        materia: practicaResponseData.materia,
        curso: practicaResponseData.curso,
        semestre: practicaResponseData.semestre,
        fechaDesde: practicaResponseData.fechaDesde,
        fechaHasta: practicaResponseData.fechaHasta,
        // fechaDesde: practicaResponseData.practicaDetalleList.length>0? practicaResponseData.practicaDetalleList[0].fechaDesde:"00/00/00 00:00:00" ,
        // fechaHasta: practicaResponseData.practicaDetalleList.length>0? practicaResponseData.practicaDetalleList[0].fechaHasta:"00/00/00 00:00:00" ,
        observacion: practicaResponseData.observacion,
        asignadas: practicaResponseData.convenioCarrera.convenio.institucionFormadora.asignadas,
        disponibles:practicaResponseData.convenioCarrera.convenio.institucionFormadora.disponibles,
        ocupadas:practicaResponseData.convenioCarrera.convenio.institucionFormadora.ocupadas
      };

      console.log('🔍 Datos de institución formadora:', practicaResponseData.convenioCarrera.convenio.institucionFormadora);
      console.log('? Valor asignadas:', practicaResponseData.convenioCarrera.convenio.institucionFormadora.asignadas);
      console.log('? formValues completo:', formValues);

      // Establecer el valor de asignadas en un estado separado
      const asignadasValue = practicaResponseData.convenioCarrera.convenio.institucionFormadora.asignadas || 0;
      setAsignadasCount(asignadasValue);
      console.log('? Estado asignadasCount establecido:', asignadasValue);

      console.log('? Estableciendo idFormadora...');
      setIdFormadora(practicaResponseData.convenioCarrera.convenio.institucionFormadora.id);
      console.log('? idFormadora establecido correctamente');

      // setFechaDesde(practicaResponseData.practicaDetalleList.length>0? practicaResponseData.practicaDetalleList[0].fechaDesde:"00/00/00 00:00:00");
      // setFechaHasta(practicaResponseData.practicaDetalleList.length>0? practicaResponseData.practicaDetalleList[0].fechaHasta:"00/00/00 00:00:00");

      // setFechaDesde(practicaResponseData.fechaDesde);X
      // setFechaHasta(practicaResponseData.fechaHasta);
      
      let contadorHorarios=0;

      

      // Recorrer el array obtenido de prácticas detalles de la base de datos 

      practicaResponseData.practicaDetalleList.forEach( async (k) => {
        
        // Obtener los horarios de cada una de las prácticas.
        const { data: practicaDetalleHorarioIdResponseData } = await trackPromise(DnerhsApi.get(
          `/practicas-detalles-horarios/${k.id}/horarios`
        ));

        k.practicaDetalleHorarioList=practicaDetalleHorarioIdResponseData;

        if(k.practicaDetalleHorarioList){
          k.practicaDetalleHorarioList.forEach((ho)=>{
            // console.log(ho);
            if(ho.dia=="1"){ 
              k.lunes=true;
            }
            if(ho.dia=="2"){ 
              k.martes=true;
            }
            if(ho.dia=="3"){ 
              k.miercoles=true;
            }
            if(ho.dia=="4"){ 
              k.jueves=true;
            }
            if(ho.dia=="5"){ 
              k.viernes=true;
            }
            if(ho.dia=="6"){ 
              k.sabado=true;
            }
            if(ho.dia=="7"){ 
              k.domingo=true;
            }
            console.log('$$$$$$$$$$$$$$ ',ho.horarioDesde);
            k.horarioDesde = ho.horarioDesde
            k.horarioHasta = ho.horarioHasta
          });
        }

        contadorHorarios++;
        console.log('contadorHorarios', contadorHorarios);
        setContadorAlumnos(contadorHorarios);

        // k.num = contadorHorarios++;
        console.log('k', k);
        if( practicaResponseData.practicaDetalleList.length===contadorHorarios){
          setListPracticas(practicaResponseData.practicaDetalleList);
          let carreraAux=getValues("carrera");
          let [responseCarreras] = await Promise.all([ getCarrerasProgramas(params.convenioId)] )
          responseCarreras.data.forEach((el)=>{
            if(el.id===carreraAux){
              setCarrAux(el.carreraPrograma.id);
            }
          });
        }
      });

      //conteoHorarios(practicaResponseData.practicaDetalleList);  
      const { data: historialResponseData } = await trackPromise(DnerhsApi.get(`/practicas-observaciones/${params.practicaId}/observaciones`
      ));
      setSent(true);
      if(historialResponseData.length>0){
        
        setHistorial(historialResponseData);
        setIsUpdateH(true);
        //reset2();
      }
      let varfechaDesde=getValues("fechaDesde");
      let varfechaHasta=getValues("fechaHasta");

      if(varfechaDesde==="00/00/00 00:00:00" ||  varfechaHasta==="00/00/00 00:00:00"){
        setDisabledAgregar(true);
      }

      // Establecer los valores del formulario (sin asignadas que ya está en estado separado)
      Object.keys(formValues).forEach((field) => {
        setValue(field, formValues[field]);
      });

    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
  };
    //handlefechaDesdeChange
  const handlefechaDesdeChange = async (e) => {
      setFechaDesde(e);
  }


  const onSubmit = async (data) => {
    if (data.carrera === "") {
      Alert.showError("El campo carrera es dato requerido");
      return;
    }else{
      let carreraAux=getValues("carrera");
      carreraOptions.forEach((el)=>{
        if(el.id===carreraAux){
          setCarrAux(el.idCarrera);
        }
      });
    }
    if (data.fechaDesde === null || data.fechaDesde === "") {
      Alert.showError("El campo Fecha Desde es dato requerido");
      return;
    }
    if (data.fechaHasta === null || data.fechaHasta === "") {
      Alert.showError("El campo Fecha Hasta es dato requerido");
      return;
    }

    let url = "/convenios/practicas ";
    let carreraIdprograma;
    let carreraDescripcionPrograma;
    carreraOptions.forEach((el)=>{
      if(el.id===data.carrera){
        carreraIdprograma=el.idCarrera;
        carreraDescripcionPrograma=el.label;
      }
    });

    let nombrePostgradoIdVar=0;

    console.log('data.fechaHasta', data.fechaHasta);

    let fechaDesdeSend = new Date(moment(data.fechaDesde).format("YYYY-MM-DD")).toISOString().slice(0, -1);
    let fechaHastaSend = new Date(moment(data.fechaHasta).format("YYYY-MM-DD")).toISOString().slice(0, -1);
    // let fechaDesdeSend = new Date(moment(data.fechaDesde).format("YYYY-MM-DD")).toISOString().replace('T', ' ').slice(0, -1);
    // let fechaHastaSend = new Date(moment(data.fechaHasta).format("YYYY-MM-DD")).toISOString().replace('T', ' ').slice(0, -1);
    
    console.log('isUpdate', isUpdate);
    // console.log('converToLocalTime()', (fechaDesde.toString()));
    // console.log('converToLocalTime()', (converToLocalTime(new Date(moment(fechaDesde).format("YYYY-MM-DD")).toISOString())));
    console.log('getValues("fechaDesde")', fechaDesdeSend);
    console.log('getValues("fechaHasta")', fechaHastaSend);

    const payload = {
      convenioCarrera: { id: data.carrera , carreraPrograma: { id: carreraIdprograma}},
      materia: data.materia,
      curso: data.curso,
      semestre: data.semestre,
      fechaDesde: fechaDesdeSend,
      fechaHasta: fechaHastaSend
      // fechaDesde: new Date(moment(fechaDesde).format("YYYY-MM-DD")).toISOString().replace('T', ' ').slice(0, -1),
      // fechaHasta: new Date(moment(data.fechaHasta).format("YYYY-MM-DD")).toISOString().replace('T', ' ').slice(0, -1)
      //practicaDetalleList: listPracticas, //2.8 
    };

    
    console.log('payload para /convenios/practicas ', payload);


    try {
      let message = "";

      if (isUpdate) {
        let payloadUpt = { ...practicaResponseData, ...payload };

        let { data } = await trackPromise(DnerhsApi.put(url, {
          ...payloadUpt,
        }));
        setSent(true);
        setPracticaResponseData(data);

        message = "Datos guardados exitosamente.";
        setIsDisabledGuardar(true);
        let varfechaDesde=getValues("fechaDesde");
        let varfechaHasta=getValues("fechaHasta");
        if(varfechaDesde==="00/00/00 00:00:00" ||  varfechaHasta==="00/00/00 00:00:00"){
          setDisabledAgregar(true);
        }else{
          setDisabledAgregar(false);
        }
      } else {
        payload.convenio = {
          id: params.convenioId,
        };

        let { data } = await trackPromise(DnerhsApi.post(url, {
          ...payload,
        }));
        setSent(true);
        setPracticaResponseData(data);
        setDisabledAgregar(false);
        message = "Datos actualizados exitosamente.";
        setIsDisabledGuardar(true);
        let varfechaDesde=getValues("fechaDesde");
        let varfechaHasta=getValues("fechaHasta");
        if(varfechaDesde==="00/00/00 00:00:00" ||  varfechaHasta==="00/00/00 00:00:00"){
          setDisabledAgregar(true);
        }else{
          setDisabledAgregar(false);
        }
      }

      Alert.show({
        message,
        type: "success",
      });
      setBotonGuardar(true);
      //setIsReadOnly(true);
      //history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
       Alert.showServerError(error);
      } 
    }
  };


  const converToLocalTime = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
      console.log('date', date, mnth, day);
    //  console.log(new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0]+' UTC').toISOString());
    return (new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0] + ' UTC').toISOString());
  }


  const handleModificar = async () => {
    try {
      // VALIDACIÓN FRONTEND: Verificar que no sea un cronograma aprobado
      if (practicaResponseData.estado === EstadosCronograma.PRACTICA_APROBADA ||
          practicaResponseData.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA) {
        Alert.show({
          message: "No se permite modificar cronogramas ya aprobados.",
          type: "error",
        });
        return;
      }

      let { id } = practicaResponseData;
      await trackPromise(DnerhsApi.post(
        `/convenios/practicas/${id}/modificar-cronograma-aprobado`
      ));
      setSent(true);
      Alert.show({
        message: "Modifición Realizada con exitosamente.",
        type: "success",
      });

      history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       }
    }
  }

  const handleSolicitarRevision = async () => {
    try {
      let { id } = practicaResponseData;

      let estado = EstadosCronograma.PENDIENTE_APROBACION;

      if (
        practicaResponseData.estado === EstadosCronograma.PRACTICA_RECHAZADA
      ) {
        estado = EstadosCronograma.PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION;
      }

      await trackPromise(DnerhsApi.post(
        `/convenios/practicas/${id}/solicitar-revision?estado=${estado}`
      ));
      setSent(true);
      Alert.show({
        message: "Solicitud de revisión enviada exitosamente.",
        type: "success",
      });

      history.push({
        pathname: `/convenios/cronogramasPracticas/${params.convenioId}`,
       
      })
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
  };

  const handleAprobarSolicitudRevision = async () => {
    try {
      let { id } = practicaResponseData;

      let estado = EstadosCronograma.PRACTICA_APROBADA;

      if ( practicaResponseData.estado === EstadosCronograma.PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION
      ) {
        estado = EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA;
      }

      let observacion = getValues("observacion");

      await trackPromise(DnerhsApi.post(
        `/convenios/practicas/${id}/aprobacion?estado=${estado}&observacion=${observacion}`
      ));
      setSent(true);
      Alert.show({
        message: "Solicitud aprobada exitosamente.",
        type: "success",
      });

      history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
  };


  const handleOpenDeleteDialog = (id, index) => {
    /*let listCopy = [...listPracticas];
    listCopy.splice(index, 1);
    setListPracticas(listCopy);*/
    //conteoHorarios(listCopy); ya no se usa
    if (isCronogramaFinalizado) {
      Alert.show({
        message: "No se puede eliminar alumnos porque el cronograma esta finalizado.",
        type: "warning"
      });
      return;
    }

    setOpenDeleteDialog(true);
    setToDelete(id);
    setIndex(index);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDialog(false);
  };

  const deleteOne = async () => {
    console.log('toDelete', toDelete);
    try {
      let message = ""; 
      let url = `/practicas-detalles/${toDelete}`;
      
      const response = await DnerhsApi.delete(url); // Solo una llamada
      console.log("response delete", response);
      message = `Registro con id ${toDelete} eliminado correctamente`;
      
      Alert.show({
        message,
        type: "success"
      });
      
      let listCopy = [...listPracticas];
      listCopy.splice(indexx, 1); 
      setListPracticas(listCopy);
      
      window.location.reload();  // Elimina esta línea si no quieres recargar la página
    } catch (error) {
      console.log('Error!', error);
      Alert.show({
        message: 'Error al eliminar el registro',
        type: 'error'
      });
    }
  
    setOpenDeleteDialog(false);
    setToDelete(null); // Asegúrate de reiniciar este valor
  };
  


  const handleOpenEstudianteDialog = async (index) => {
    loadAllSolicitudes();
    setCurso(getValues("curso"))
    let estudiante = { ...listPracticas[index] };
    setPracticaSelected(estudiante);
    setOpenPracticaDialog(true);
    let carreraAux=getValues("carrera");
    let carrAux;
      carreraOptions.forEach((el)=>{
        if(el.id===carreraAux){
          carrAux=el.idCarrera;
        }
      });
    let [responseTutores, responseEstudintes] = await Promise.all([
      getTutores(params.convenioId, carrAux),
      getEstudiantes(params.convenioId, carrAux)
    ])
    setTutotresConvenioList(responseTutores.data);
    setEstudiantesResponseData(responseEstudintes.data);
  };

  const showObservacion =
    practicaResponseData.id &&
    (practicaResponseData.estado === EstadosCronograma.PENDIENTE_APROBACION ||
      practicaResponseData.estado === EstadosCronograma.PRACTICA_RECHAZADA ||
      practicaResponseData.estado === EstadosCronograma.PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION);

  const showButtonSolicitar = ((practicaResponseData.id &&
      practicaResponseData.estado === EstadosCronograma.CREADA ||
      practicaResponseData.estado === EstadosCronograma.CREADA_PROCESO ||
      practicaResponseData.estado === EstadosCronograma.PRACTICA_RECHAZADA ) &&  listPracticas.length>0);

  const showButtonsAprobacion = hasAnyRole([Roles.ROLE_DNERHS, Roles.ROLE_ADMIN]) && isAprobar;

  const showButtonFinalizar = practicaResponseData.id &&
    (
      practicaResponseData.estado === EstadosCronograma.PRACTICA_APROBADA ||
      practicaResponseData.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA);

  // SOLUCIÓN BUG: Determinar si se puede editar basado en estado del cronograma
  // EXCEPCIÓN: Si el usuario es DNERHS, puede editar en algunos estados
  // IMPORTANTE: Estado FINALIZADA está bloqueado para TODOS (incluso DNERHS)
  const isDnerhsUser = hasRole(Roles.ROLE_DNERHS);
  const isCronogramaFinalizado = practicaResponseData.estado === EstadosCronograma.PRACTICA_CRONOGRAMA_FINALIZADA;
  const canRectificarAlumno = isDnerhsUser && practicaResponseData.id;
  const canAgregarAlumno = (!isReadOnly || isDnerhsUser) && practicaResponseData.id;

  // Si está FINALIZADA, NADIE puede editar (ni DNERHS)
  if (isCronogramaFinalizado) {
    var canEditCronograma = false;
  }
  // Si es DNERHS y NO está finalizada, puede editar
  else if (isDnerhsUser) {
    var canEditCronograma = true;
  }
  // Si NO es DNERHS, validar estados normalmente
  else {
    var canEditCronograma = !isReadOnly &&
      practicaResponseData.estado !== EstadosCronograma.PRACTICA_APROBADA &&
      practicaResponseData.estado !== EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA &&
      practicaResponseData.estado !== EstadosCronograma.PENDIENTE_APROBACION &&
      practicaResponseData.estado !== EstadosCronograma.PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION;
  }
  const checkDayFormat = (day) => {
    return day ? (
      <CheckIcon color="secondary" />
    ) : (
      <CloseIcon color="primary" />
    );
  };

  const renderAccionesEstudiante = (row, index) => (
    <TableCell align="center" className={classes.actionsCell}>
      <Box className={classes.actionsBar}>
        {canEditCronograma ? (
          <>
            <Tooltip
              title={isCronogramaFinalizado ? "No se puede eliminar alumnos de un cronograma finalizado" : "Eliminar"}
              aria-label="eliminar"
            >
              <IconButton
                size="small"
                aria-label="eliminar"
                color="default"
                className={`${classes.actionButton} ${classes.deleteAction}`}
                disabled={isCronogramaFinalizado || !hasAnyRole([Roles.ROLE_USER, Roles.ROLE_DNERHS])}
                onClick={() => handleOpenDeleteDialog(row.id, index)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar" aria-label="editar">
              <IconButton
                size="small"
                aria-label="editar"
                color="secondary"
                className={`${classes.actionButton} ${classes.editAction}`}
                disabled={!hasAnyRole([Roles.ROLE_USER, Roles.ROLE_DNERHS])}
                onClick={() => history.push({
                  pathname:`/convenios/cronogramasPracticas/estudiante/editar/${params.convenioId}/${row.id}`,
                  state: {
                    fechaDesde: `${getValues("fechaDesde")}`,
                    fechaHasta: `${getValues("fechaHasta")}`,
                    carrera: `${carrAux} `,
                    idFormadora: `${idFormadora} `,
                    anio: `${getValues("curso")}`,
                    edit: true,
                    parentReadOnly: isReadOnly
                  }
                })}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            {hasRole(Roles.ROLE_DNERHS) && (
              <Tooltip title="Rectificado" aria-label="rectificado">
                <IconButton
                  size="small"
                  aria-label="rectificado"
                  color="primary"
                  className={`${classes.actionButton} ${classes.rectificarAction}`}
                  onClick={() => {
                    setSelectedEstudiante(row);
                    setOpenRectificadoModal(true);
                  }}
                >
                  <AssignmentIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        ) : (
          <>
            <Tooltip title="Ver" aria-label="ver">
              <IconButton
                size="small"
                aria-label="ver"
                color="secondary"
                className={`${classes.actionButton} ${classes.viewAction}`}
                onClick={() => history.push({
                  pathname:`/convenios/cronogramasPracticas/estudiante/editar/${params.convenioId}/${row.id}`,
                  state: {
                    fechaDesde: `${getValues("fechaDesde")}`,
                    fechaHasta: `${getValues("fechaHasta")}`,
                    carrera: `${carrAux} `,
                    idFormadora: `${idFormadora} `,
                    anio: `${getValues("curso")}`,
                    readOnly: true,
                    parentReadOnly: isReadOnly,
                    parentIsVerMode: isVerMode
                  }
                })}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            {canRectificarAlumno && (
              <Tooltip title="Rectificado" aria-label="rectificado">
                <IconButton
                  size="small"
                  aria-label="rectificado"
                  color="primary"
                  className={`${classes.actionButton} ${classes.rectificarAction}`}
                  onClick={() => {
                    setSelectedEstudiante(row);
                    setOpenRectificadoModal(true);
                  }}
                >
                  <AssignmentIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        )}
      </Box>
    </TableCell>
  );

  /*MODAL*/
  const [modal, setModal]=useState(false);
  const abrirCerrarModal =(accion)=>{
    setModal(!modal);
    setBandera(accion);    
  }
    const cerrarModal =()=>{  
    setModal(!modal);    
  }
  const handleObservacionChange = ( value) => {
    //rechazoObservacion=value;
    setRechazoObservacion(value);
  };
  
  const handleRechazarSolicitudRevision = async () => {
    if(bandera!="rechazar"){
      abrirCerrarModal("");
      confirmOne();
    }else{
      abrirCerrarModal("");
      try {
        let { id } = practicaResponseData;

        //let observacion = getValues("observacion");

        if (observacion == "") {
          Alert.show({
            message : "Por favor ingrese una observación",
            type : "error"
          });
          return;
        }

        await trackPromise(DnerhsApi.post(
          `/convenios/practicas/${id}/aprobacion?estado=${EstadosCronograma.PRACTICA_RECHAZADA}&observacion=${observacion}`
        ));
        setSent(true);
        Alert.show({
          message: "Solicitud rechazada exitosamente.",
          type: "success",
        });

        history.goBack();
      } catch (error) {
        console.log(error);
        if (error.response) {
          Alert.showServerError(error);
        } 
      }
    }
  };
  //  <Box sx={classes.box}>
  const bodyModal= (
    
    <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}>
      <Paper>
        <Card>
        <CardContent>
          <div>
          <br/>
          <Typography align="center" variant="h5" color="primary">
          Observaciones Cronograma
              </Typography>
      
               <br/>
  
          </div>
          <br/> <br/>
          <Grid item className={classes.field}>
          <TextareaAutosize aria-label="Observacion"  rows={6} rowsMax={10}  placeholder="Observaciones" onChange={(e) =>
                                  handleObservacionChange(e.target.value)}
                                  style={{width: 600, fontSize: 0.875+'rem', fontFamily: 'Roboto', fontWeight: 400,
                                  lineHeight: 1.43,
                                  letterSpacing: 0.01071+'em', borderRadius: 10+'px'}}
                                  />
          </Grid>
          <br/> <br/>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        
           
            <Grid item className={classes.field}>
              <Button
                variant="contained"
                color="default"
                onClick={()=>cerrarModal()}>Cancelar
              </Button>
            </Grid>
            <Grid item className={classes.field}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleRechazarSolicitudRevision}
                >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      </Paper>
    </div>
    
  )
 
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
 
/*linea 589
  <TableCell align="center">
                          {findById(row.mesDesde)?.nombre +
                            " a " +
                            findById(row.mesHasta)?.nombre}{" "}
                        </TableCell>
*/
  return (
    <>
      <Paper>
        <Box padding={5}>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" color="primary">
              Cronograma de Prácticas
            </Typography>
            <br/>
          </Grid>

          {/* Estadísticas del Cronograma */}
          <Grid item xs={12} className={classes.statsContainer}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Chip
                  icon={<PeopleIcon />}
                  label={`${listPracticas.length || contadorAlumnos || 0} Alumnos`}
                  className={classes.statChip}
                  style={{ backgroundColor: '#e3f2fd', color: '#1976d2' }}
                />
              </Grid>
              <Grid item>
                <Chip
                  icon={<PeopleIcon />}
                  label={`${asignadasCount} Asignados`}
                  className={classes.statChip}
                  style={{ backgroundColor: '#e8f5e8', color: '#388e3c' }}
                />
              </Grid>
              {fechaCreacion && (
                <Grid item>
                  <Chip
                    icon={<DateRangeIcon />}
                    label={`Creado: ${fechaCreacion}`}
                    className={classes.statChip}
                    style={{ backgroundColor: '#fff3e0', color: '#f57c00' }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <FormProvider {...methods}>
              <form>
                <Grid container direction="row">
                  <Grid item xs={6}>
                    <Grid item xs={12} className={classes.field}>
                      <FormSelect
                        name="carrera"
                        label="Carrera"
                        disabled={isReadOnly || isUpdate}
                        options={carreraOptions}  
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        name="materia"
                        label="Materia"
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field} >
                      <FormDatePicker name="fechaDesde" label="Fecha desde" disabled={isReadOnly} />                          
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        type="number"
                        name="curso"
                        label="Curso"
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        type="number"
                        name="semestre"
                        label="Semestre"
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                          <FormDatePicker name="fechaHasta" label="Fecha hasta"  disabled={isReadOnly}/>
                        </Grid>
                  </Grid>
               
                </Grid>
                {/* Campo "Asignadas" oculto - se muestra en estadísticas */}

                {/* Campo "Cantidad de alumnos" oculto - se muestra en estadísticas */}
                
              </form>
            </FormProvider>
          </Grid>
          <Grid item xs={12}>
            <Box paddingTop={3}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                
                {/* FUNCIONALIDAD REMOVIDA: No se permite modificar cronogramas aprobados
                { (hasRole(Roles.ROLE_USER)  && (practicaResponseData.estado==='Práctica aprobada por DNERHS' || practicaResponseData.estado==='Práctica con modificaciones aprobadas por DNERHS')) && (
                  <>

                      <Grid item className={classes.field}>
                        <Button   style={{ color:"#fff" ,  backgroundColor: "#333e65"  }}
                          variant="contained"
                          color="#333e65"
                          onClick={handleModificar}

                        >
                          Modificar
                        </Button>
                      </Grid>

                  </>
                )}
                */}
                {hasAnyRole([Roles.ROLE_USER, Roles.ROLE_DNERHS]) && (
                  <>
                    {(!isReadOnly || (hasRole(Roles.ROLE_DNERHS) && practicaResponseData.estado !== EstadosCronograma.PRACTICA_CRONOGRAMA_FINALIZADA)) && (
                      <Grid item className={classes.field}>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={isReadOnly && !hasRole(Roles.ROLE_DNERHS)}
                          onClick={handleSubmit(onSubmit)}
                        >
                           { !isUpdate ? ( "Guardar"):("Editar")}
                        </Button>
                      </Grid>
                    )}

                  </>
                )}
               
               
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 16 }}>
            <Typography align="center" variant="h6" color="primary">
              Estudiantes
            </Typography>
          </Grid>

          {/* Buscador Profesional */}
          <Grid item xs={12} className={classes.searchContainer}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Buscar por alumno, CI, tutor, establecimiento, etc..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
              size="small"
            />
            {searchTerm && (
              <Box mt={1}>
                <Typography variant="body2" color="textSecondary">
                  {filteredPracticas.length} de {listPracticas.length} estudiantes encontrados
                </Typography>
              </Box>
            )}
          </Grid>

          <Grid item xs={12}>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label="Cronograma de Prácticas" size="small">
                  <TableHead className={classes.tableHeader}>
                    <TableRow>
                      <TableCell align="center"><strong>Acciones</strong></TableCell>
                      <TableCell><strong>C.I. Alumno</strong></TableCell>
                      <TableCell><strong>Curso</strong></TableCell>
                      <TableCell><strong>Año</strong></TableCell>
                      <TableCell><strong>Alumno</strong></TableCell>
                      <TableCell><strong>Nacionalidad</strong></TableCell>
                      <TableCell><strong>Sede</strong></TableCell>
                      <TableCell align="center"><strong>D</strong></TableCell>
                      <TableCell align="center"><strong>L</strong></TableCell>
                      <TableCell align="center"><strong>M</strong></TableCell>
                      <TableCell align="center"><strong>X</strong></TableCell>
                      <TableCell align="center"><strong>J</strong></TableCell>
                      <TableCell align="center"><strong>V</strong></TableCell>
                      <TableCell align="center"><strong>S</strong></TableCell>
                      <TableCell><strong>Horario</strong></TableCell>
                      <TableCell align="center"><strong>Total Horas</strong></TableCell>
                      <TableCell><strong>C.I. Tutor</strong></TableCell>
                      <TableCell><strong>Tutor</strong></TableCell>
                      <TableCell><strong>Horario Tutor</strong></TableCell>
                      <TableCell><strong>Establecimiento</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredPracticas.map((row, index) => (
                      <TableRow
                        className={classes.tableRow}
                        style={
                          row.modificado ? { backgroundColor: "#fff3cd" } : {}
                        }
                        key={index}
                      >
                        {renderAccionesEstudiante(row, index)}
                        <TableCell>
                          <Chip
                            label={row.convenioEstudiante?.estudiante.cedulaIdentidad}
                            size="small"
                            style={{ backgroundColor: '#e3f2fd', color: '#1976d2', fontWeight: 600 }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={row.convenioEstudiante?.curso}
                            size="small"
                            style={{ backgroundColor: '#fff3e0', color: '#f57c00' }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={row.convenioEstudiante?.anio}
                            size="small"
                            style={{ backgroundColor: '#e8f5e8', color: '#388e3c' }}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <Box display="flex" flexDirection="column" gap={0.5}>
                            <span>
                              {row.convenioEstudiante?.estudiante.nombres}&nbsp;{row.convenioEstudiante?.estudiante.apellidos}
                            </span>
                            {row.rectificado && (
                              <Tooltip
                                title={
                                  <div>
                                    <div style={{ fontWeight: 700, marginBottom: 4 }}>RECTIFICADO</div>
                                    {row.fechaDesdeRectificado && row.fechaHastaRectificado && (
                                      <div style={{ marginBottom: 4 }}>
                                        <strong>Período:</strong> {formatDateOnly(row.fechaDesdeRectificado)} - {formatDateOnly(row.fechaHastaRectificado)}
                                      </div>
                                    )}
                                    {row.observacionRectificado && (
                                      <div>
                                        <strong>Observación:</strong> {row.observacionRectificado}
                                      </div>
                                    )}
                                  </div>
                                }
                                arrow
                                placement="right"
                              >
                                <Chip
                                  label="RECTIFICADO"
                                  size="small"
                                  icon={<AssignmentIcon style={{ fontSize: 16 }} />}
                                  style={{
                                    backgroundColor: '#fff3e0',
                                    color: '#e65100',
                                    fontWeight: 700,
                                    border: '1px solid #ffb74d',
                                    width: 'fit-content'
                                  }}
                                />
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell align="left">
                          {row.convenioEstudiante?.estudiante.nacionalidad.nombre}
                        </TableCell>
                        <TableCell align="left">
                          {row.convenioEstudiante?.convenio.institucionFormadora.sede}
                        </TableCell>
                       
                        <TableCell align="left">
                          {checkDayFormat(row.domingo)}
                        </TableCell>
                        <TableCell align="left">
                          {checkDayFormat(row.lunes)}
                        </TableCell>
                        <TableCell align="left">
                          {checkDayFormat(row.martes)}
                        </TableCell>
                        <TableCell align="left">
                          {checkDayFormat(row.miercoles)}
                        </TableCell>
                        <TableCell align="left">
                          {checkDayFormat(row.jueves)}
                        </TableCell>
                        <TableCell align="left">
                          {checkDayFormat(row.viernes)}
                        </TableCell>
                        <TableCell align="left">
                          {checkDayFormat(row.sabado)}
                        </TableCell>
                       
                        <TableCell align="left">
                          {row.horarioDesde + " - " + row.horarioHasta}
                        </TableCell>

                        <TableCell align="left">
                          {row.totalHoras + " hs"}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={row.convenioTutor?.tutor?.cedulaIdentidad}
                            size="small"
                            style={{ backgroundColor: '#ffebee', color: '#d32f2f', fontWeight: 600 }}
                          />
                        </TableCell>
                        <TableCell>
                          <strong style={{ color: '#d32f2f' }}>
                            {row.convenioTutor?.tutor?.nombres} {row.convenioTutor?.tutor?.apellidos}
                          </strong>
                        </TableCell>

                        <TableCell align="left">
                          {row.horarioDesde + " - " + row.horarioHasta}
                        </TableCell>

                        <TableCell align="left">
                          {row.establecimiento?.nombreServicio.nombre}
                        </TableCell>

                      </TableRow>
                    ))}
                    {filteredPracticas.length === 0 && searchTerm && (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <Box p={3}>
                            <Typography variant="body1" color="textSecondary">
                              No se encontraron resultados para "{searchTerm}"
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                    {filteredPracticas.length === 0 && !searchTerm && listPracticas.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <Box p={3}>
                            <Typography variant="body1" color="textSecondary">
                              No hay estudiantes asignados en este cronograma
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignContent="flex-end"
            >

              {canAgregarAlumno && (
                <Grid item className={classes.field}>
                  <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push({
                    pathname:`/convenios/cronogramasPracticas/estudiante/${params.convenioId}/${practicaResponseData.id}`,
                    state: {
                      fechaDesde: `${getValues("fechaDesde")}`,
                      fechaHasta: `${getValues("fechaHasta")}`,
                      carrera: `${carrAux} `,
                      idFormadora: `${idFormadora} `,
                      anio: `${getValues("curso")}`,
                      parentReadOnly: isReadOnly,
                      parentIsVerMode: isVerMode
                    }
                  })}
                  //disabled={!isDisabledGuardar }
                  disabled={disabledAgregar && !hasRole(Roles.ROLE_DNERHS)}
                  >
                    agregar
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
          {(verHistorial) && (
                  <Grid item xs={12}>
                    <Grid item xs={12} className={classes.field}>
                      <Typography align="center" variant="h6" color="primary">
                        Historial de Observaciones
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TableContainer component={Paper}>
                        <Table aria-label="Datos estadisticos">
                          <TableHead>
                            <TableRow>                              
                              <TableCell align="left">Fecha Observación</TableCell>
                              <TableCell align="left">Observación</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {historial.map((row, index) => (
                                <TableRow key={index}>                          

                                 
                                  <TableCell align="left">
                                    {row.fechaCreacion}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.observacion}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                )}
          <Grid item xs={12}>
            <Box paddingTop={3}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item className={classes.field}>
                  <Button
                    variant="contained"
                    color="default"
                    onClick={() => {
                      // Si viene de asignación de plazas, volver allá
                      if (state?.fromAsignacionPlazas) {
                        history.goBack();
                      } else {
                        // Si no, ir a la lista de cronogramas
                        history.push({
                          pathname: `/convenios/cronogramasPracticas/${params.convenioId}`
                        });
                      }
                    }}
                  >
                    Atrás
                  </Button>
                </Grid>
         
                {hasRole(Roles.ROLE_USER) && (
                  <>
                  

                    {(showButtonSolicitar || botonGuardar) && (
                      <Grid item className={classes.field}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={handleSolicitarRevision}
                        >
                          Solicitar
                        </Button>
                      </Grid>
                    )}
                   
                  </>
                )}
                {showButtonsAprobacion && (
                  <>
                    <Grid item className={classes.field}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => abrirCerrarModal("rechazar")}
                      >
                        Rechazar
                      </Button>
                    </Grid>
                    <Grid item className={classes.field}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAprobarSolicitudRevision}
                      >
                        Aprobar
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
            <DeleteDialog
            open={openDeleteDialog}
            onClose={handleCloseDeleteDialog}
            onAccept={deleteOne}
            aria-labelledby="form-dialog-title"
          />
          </Grid>
          
          
        </Box>
        <ConfirmDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onAccept={confirmOne}
            aria-labelledby="form-dialog-title"
          />
      </Paper>
      <Modal backdrop="static"
        open={modal} variant="standard"
        InputProps={{
                disableUnderline: true,
              }}
              style={{outline: 'none'}}
              classes={{focused: classes.outlinedInputFocused}}
      >
      
        {bodyModal}
      </Modal>
     
      <PracticaEstudianteDialog
        mapHorarios={mapHorarios}
        fechaDesde={fechaDesde}
        fechaHasta={fechaHasta}
        curso={curso}
        dataForEdit={practicaSelected}
        tutoresConvenioList={tutoresConvenioList}
        establecimientosList={establecimientosList}
        plazasList={plazasList}
        estudiantesConvenioList={estudiantesResponseData}
        open={openPracticaDialog}
        isReadOnly={isReadOnly}
        onSave={handleSaveCronogramaPractica}
        onClose={handleCloseCronogramaPractica}
        aria-labelledby="form-dialog-title"
      />

      <RectificadoModal
        open={openRectificadoModal}
        onClose={(saved) => {
          setOpenRectificadoModal(false);
          setSelectedEstudiante(null);
          if (saved) {
            // Refresh the list to show updated rectificado status
            setValuesForEdit();
          }
        }}
        estudianteData={selectedEstudiante}
      />
    </>
  );
};

export default Form;
